import React from 'react'
import { Pie } from 'react-chartjs-2';
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';


const styleCard ={
    borderRadius: '1rem',
}

const MonthlyPieChart = () => {

  const data = {
    labels: ["Cold Email", "Lead", "Trial"],
    datasets: [
      {
        label: "Dataset 1",
        data: [12, 19, 3],
        backgroundColor: [
          "rgba(255, 206, 86, 0.6)", // Yellow
          "rgba(153, 102, 255, 0.6)", // Purple
          "rgba(75, 192, 192, 0.6)", // Green
        ],
        borderColor: [
          "rgba(255, 206, 86, 1)", // Yellow
          "rgba(153, 102, 255, 1)", // Purple
          "rgba(75, 192, 192, 1)", // Green
        ],
        borderWidth: 1,
      },
    ],
  };

  // Options for customization
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Simple Pie Chart Example",
      },
    },
  };

  return (
    <>
      <Card style={styleCard}>
        <CardBody>
          <CardTitle>Monthly Activity</CardTitle>
          <Pie data={data} options={options} height="255" />
        </CardBody>
      </Card>
    </>
  );
};

export default MonthlyPieChart